/* Shared chrome for /login and /setup (prototype authTop + authSide). */
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../../i18n";
import { Icon, IconButton } from "../../../ui";
import type { CountryInfo } from "../../../domain/country";
import { inCountry } from "../mktCountry";
import { LangSwitch, MktLink } from "./MktLink";

/** Sign-in and sign-up buttons are always there: on /setup "Sign in" is the main one, elsewhere "Sign up";
 * `both` shows the two together (pricing, video). `country` (from ?country=) makes Home go back to that country's page. */
export function AuthTop({ signIn = false, both = false, country }: { signIn?: boolean; both?: boolean; country?: CountryInfo }) {
  const i = useI18n();
  const { L, t } = i;
  const home = country ? inCountry("/home", country) : "/home";
  const q = country?.slug ? "?country=" + country.slug : "";
  return (
    <div className="row between auth-top" style={{ marginBottom: "auto" }}>
      <MktLink to={home} className="row nw auth-brand" style={{ textDecoration: "none", color: "inherit" }}>
        <span className="brand-mark">{L("S", "س")}</span><b>{L("StartHR", "ستارت HR")}</b>
      </MktLink>
      <div className="row">
        <MktLink className="btn ghost sm mkt-hide-sm" to={home} data-testid="auth-home"><Icon name="home" className="s" /><span>{L("Home", "الرئيسية")}</span></MktLink>
        <MktLink className="btn ghost sm mkt-hide-sm" to="/pricing"><span>{L("Pricing", "الأسعار")}</span></MktLink>
        {both && <Link className="btn sm" to={"/login" + q} data-testid="auth-signin"><span>{t("Sign in")}</span></Link>}
        {signIn && !both
          ? <Link className="btn pri sm" to={"/login" + q} data-testid="auth-signin"><span>{t("Sign in")}</span></Link>
          : <Link className="btn pri sm" to={"/setup" + q} data-testid="auth-signup"><span>{L("Sign up", "إنشاء حساب")}</span></Link>}
        <LangSwitch className="btn sm" label={i.isAr ? "Switch to English" : t("Switch to Arabic")}>{L("العربية", "English")}</LangSwitch>
        <IconButton icon={i.isDark ? "sun" : "moon"} label={i.isDark ? t("Light mode") : t("Dark mode")} onClick={i.toggleTheme} data-testid="theme-toggle" />
      </div>
    </div>
  );
}

export function AuthSide({ title, text }: { title: ReactNode; text: ReactNode }) {
  const { L, t } = useI18n();
  return (
    <aside className="auth-side">
      <div className="tiles" aria-hidden="true"><i /><i className="w" /><i className="g" /><i /><i className="w" /><i /><i /><i /><i className="g w" /><i /></div>
      <div className="row nw"><span className="brand-mark">{L("S", "س")}</span><b style={{ fontSize: 17 }}>{L("StartHR", "ستارت HR")}</b></div>
      <div><h2>{title}</h2><p className="muted" style={{ maxWidth: "42ch", fontSize: 15 }}>{text}</p></div>
      <div className="row muted sm"><Icon name="shield" className="s" />{t("Data hosted in KSA")} · PDPL · ISO 27001</div>
    </aside>
  );
}
